import { render, staticRenderFns } from "./comparisons.vue?vue&type=template&id=556c8c1d&scoped=true&"
import script from "./comparisons.vue?vue&type=script&lang=js&"
export * from "./comparisons.vue?vue&type=script&lang=js&"
import style0 from "./comparisons.vue?vue&type=style&index=0&id=556c8c1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c8c1d",
  null
  
)

export default component.exports